import React, { FC, ReactNode, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faDesktop,
    faMoon,
    faSun,
} from "@fortawesome/free-solid-svg-icons";
import useTheme, { ThemeSetting } from "../../../hooks/useTheme";

interface ThemeIconProps {
    value: ThemeSetting;
    icon: ReactNode;
    label: string;
}

const ThemeMenu: FC = () => {

    const themeIconProps: ThemeIconProps[] = [
        { value: "light", icon: <FontAwesomeIcon icon={faSun} size="xs" fixedWidth />, label: "Light" },
        { value: "dark", icon: <FontAwesomeIcon icon={faMoon} size="xs" fixedWidth />, label: "Dark" },
        { value: "system", icon: <FontAwesomeIcon icon={faDesktop} size="xs" fixedWidth />, label: "System" },
    ];

    const { theme, setTheme } = useTheme();
    const [ expanded, setExpanded ] = useState(false);

    useEffect(() => {
        console.log(theme);
    }, [ theme ]);

    return (
        <div
            className={
                "relative h-10 transition-all duration-300 ease-in-out " +
                "flex flex-row-reverse items-center justify-start " +
                (expanded ? "w-[100px]" : "w-10")
            }
            onMouseEnter={() => setExpanded(true)}
            onMouseLeave={() => setExpanded(false)}
        >
            <div
                className={
                    "absolute right-0 flex flex-row-reverse items-center h-full px-2 " +
                    "overflow-hidden transition-all duration-300 "
                }
            >
                {themeIconProps.map(({ value, icon, label }) => (
                    <button
                        key={value}
                        onClick={() => setTheme(value)}
                        className={
                            "rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-all duration-300 " +
                            ((!expanded && theme !== value)
                             ? "text-brand-200 dark:text-gray-500 px-0 ml-0 opacity-0 w-0 "
                             : (theme === value
                                ? "text-brand-600 dark:text-white px-1 ml-1 opacity-100 w-6 "
                                : "text-brand-200 dark:text-gray-500 px-1 ml-1 opacity-100 w-6 "))
                        }
                        aria-label={`Set theme to ${label}`}
                        title={label}
                    >
                        {icon}
                    </button>
                ))}
            </div>
        </div>
    );
};

interface Props {
    heading: ReactNode;
    subHeading?: ReactNode;
}

const AdminNavbar: FC<Props> = ({
    heading,
    subHeading = (<></>),
}) => {
    return (
        <>
            <header
                className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 pr-8 backdrop-blur-xl dark:bg-[#0b14374d]"
            >
                <div className="w-full flex flex-row flex-wrap items-center justify-between">
                    <div className="ml-1.5">
                        <div className="h-6 w-[224px] pt-1">
                        </div>
                        <div className="flex-shrink m-0 font-bold capitalize text-[33px] text-brand-700 hover:text-brand-700 dark:text-white dark:hover:text-white">
                            { heading }
                        </div>
                    </div>

                    <div
                        className="relative mt-[3px] flex h-[61px] min-w-[61px] items-center justify-around gap-2 rounded-full
                                   bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-brand-700 dark:shadow-none"
                    >
                        <ThemeMenu />
                        {/*<div*/}
                        {/*    className="cursor-pointer text-gray-600"*/}
                        {/*    onClick={() => {*/}
                        {/*        if (darkmode) {*/}
                        {/*            document.body.classList.remove("dark");*/}
                        {/*            setDarkmode(false);*/}
                        {/*        } else {*/}
                        {/*            document.body.classList.add("dark");*/}
                        {/*            setDarkmode(true);*/}
                        {/*        }*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    {darkmode ? (*/}
                        {/*        <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white"/>*/}
                        {/*    ) : (*/}
                        {/*        <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white"/>*/}
                        {/*    )}*/}
                        {/*</div>*/}
                    </div>
                </div>
                <div className="w-full">
                    { subHeading }
                </div>
            </header>

        </>
    );
};

export default AdminNavbar;